import styled from '@emotion/styled';
import { LeagueLockedIcon, LeagueBadge1Icon, LeagueBadge2Icon, LeagueBadge3Icon, LeagueBadge4Icon, LeagueBadge5Icon, LeagueBadge6Icon } from '@seedlang/icons';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { observer } from 'mobx-react';
import React from 'react';
import LeagueRank from './league_rank';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${props => props.margin};
  svg {
    width: ${props => props.width};
    height: auto;
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  right: -10px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const badgeComponents = {
  0: LeagueLockedIcon,
  1: LeagueBadge1Icon,
  2: LeagueBadge2Icon,
  3: LeagueBadge3Icon,
  4: LeagueBadge4Icon,
  5: LeagueBadge5Icon,
  6: LeagueBadge6Icon
};

@observer
class LeagueBadgeIcon extends React.Component {
  static defaultProps = {
    width: '80px',
  };

  render() {
    const Icon = badgeComponents[this.props.leagueLevelPosition];
    if (!Icon) return null;
    return (
      <Wrapper
        width={this.props.width}
        margin={this.props.margin}
      >
        <Icon {...this.props} />
        {
          this.props.showRank && !this.props.showIcon &&
            <IconWrapper>
              <LeagueRank
                promotionStatus={this.props.promotionStatus}
                borderColor={this.props.borderColor}
                displayOverBadge
              >
                {this.props.rank}
              </LeagueRank>
            </IconWrapper>
        }
        {
          this.props.showIcon && this.props.promotionStatus !== 0 &&
            <IconWrapper>
              <LeagueRank
                promotionStatus={this.props.promotionStatus}
                borderColor={this.props.borderColor}
                displayOverBadge
              >
                <i className={`fa fa-${this.props.promotionStatus === 1 ? 'chevron-up' : 'chevron-down'}`} />
              </LeagueRank>
            </IconWrapper>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(LeagueBadgeIcon);